module.exports = __webpack_public_path__ + "static/img/3_3_2.ab1f382b.jpg";